export const VALIDATE_TOKEN_REQUEST = 'VALIDATE_TOKEN_REQUEST';
export const VALIDATE_TOKEN_COMPLETE = 'VALIDATE_TOKEN_COMPLETE';

export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
export const DISMISS_SESSION_TIMEOUT = 'DISMISS_SESSION_TIMEOUT';

export const LOGIN = 'LOGIN';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';

export const SUBMIT_COMPLETED = 'SUBMIT_COMPLETED';
export const RESET_SUBMIT_SUCCEEDED = 'RESET_SUBMIT_SUCCEEDED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';

export const AUTH_ERRORS = 'AUTH_ERRORS';

export const SET_INITIAL_PROPS = 'SET_INITIAL_PROPS';

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_ERROR = 'UPDATE_PASSWORD_ERROR';
export const SHOW_NOTICE = 'SHOW_NOTICE';
export const HIDE_NOTICE = 'HIDE_NOTICE';
